import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const attributeMaterialLinkUiNodeSpec: NodeSpec<NodeCfg<'attributeMaterialLink'>> = {
    suppressNode: true,
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { attributeId: '' }, id: getUID(), kind: 'attributeMaterialLink', disabled: false, width: 220 }),
    controls: nodeCfg => ({
        attributeId: defineControlOpts({
            cfg: { kind: 'createMaterialAttributes', label: 'Attribute' },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.attributeId,
        }),
    }),
    inputs: nodeCfg => ({
        trigger: { socket: 'event', label: 'Trigger' },
        materialId: {
            controlOpts: defineControlOpts({
                cfg: { kind: 'text' },
                value: nodeCfg.socketDefaults?.inputs?.materialId,
                on: { 'update:value': defaultControlUpdateValueHandler },
            }),
            socket: 'string',
            label: 'Material ID',
        },
    }),
    kindLabel: 'Attribute Material Link',
    nodeCategory: 'material',
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: node => node.controlValues.attributeId
        ? true
        : { attributeId: 'Attribute ID is required' },
};
